export enum ESchemaContentStatus {
    All = -1,
    Draft = 0,
    Published = 1
}
